import { Box } from '@mui/material'
import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import {
  base_colorContentBorder,
  text_colorTextPrimary,
  text_colorTextSecondary,
  text_colorTextTertiary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import Markdown from 'markdown-to-jsx'
import styled from 'styled-components'

export const ChatWrapper = styled(Box)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

export const ChatBox = styled.div`
  padding: ${spacing(6)};
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};
  scrollbar-color: ${styleConstants.colors.gray_dark} transparent;
  ::-webkit-scrollbar-track {
    background: transparent;
  }
`

export const InputBox = styled.div`
  border-top: 1px solid ${base_colorContentBorder};
  padding: ${spacing(4)};
  margin: 0 ${spacing(6)} ${spacing(6)} ${spacing(6)};
`

export const ChatMarkdown = styled(Markdown)`
  ${getFontCss(
    16,
    themeConstants.colors.font_primary,
    styleConstants.fontFamilies.regular,
  )};

  strong {
    font-weight: normal;
    ${getFontCss(
      16,
      themeConstants.colors.font_primary,
      styleConstants.fontFamilies.medium,
    )};
  }

  h1 {
    margin-bottom: ${spacing(4)};
  }
  h2 {
    margin-bottom: ${spacing(3)};
  }
  h3 {
    margin-bottom: ${spacing(2)};
  }
  h4 {
    margin-bottom: ${spacing(1)};
  }

  p {
    margin: 0 0 ${spacing(4)} 0;
  }

  a {
    text-decoration: underline;
    color: ${themeConstants.colors.cta};
  }

  ol,
  ul {
    margin: 0 0 ${spacing(2)} ${spacing(4)};
    padding: 0;
  }

  li {
    margin-bottom: ${spacing(2)};

    p {
      margin: 0 0 ${spacing(1)} 0;
    }

    ul,
    ol {
      margin-top: ${spacing(2)};
    }
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  ul ul,
  ol ol,
  ul ol,
  ol ul {
    margin-bottom: ${spacing(4)};
  }

  table,
  tbody,
  thead {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: ${spacing(2)};
  }
  table {
    margin-bottom: ${spacing(4)};
  }
  tr {
    min-width: 100%;
    display: flex;
    gap: ${spacing(4)};
    padding: 8px 0;
    border-bottom: 1px solid ${styleConstants.colors.gray_dark};
  }
  tbody tr {
    border-bottom: 1px solid ${styleConstants.colors.gray_dark};
  }
  td,
  th {
    flex: 1 1 50%;
  }
`

export const MessageWrapper = styled(Box)<{ sender: 'user' | 'ai' }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: ${(props) =>
    props.sender === 'user' ? 'flex-end' : 'flex-start'};
`

export const Timestamp = styled.span`
  ${getFontCss(
    10,
    styleConstants.colors.gray_darkest,
    styleConstants.fontFamilies.regular,
  )};
  margin-bottom: ${spacing(1)};
`

export const MessageBox = styled.span<{ sender: 'user' | 'ai' }>`
  width: ${(props) => (props.sender === 'user' ? '85%' : '100%')};
  padding: ${(props) => (props.sender === 'user' ? '12px' : '12px 0')};
  background-color: ${(props) =>
    props.sender === 'user'
      ? styleConstants.colors.gray_medium
      : 'transparent'};
  border-radius: 8px;
`

export const LoadingText = styled.div`
  display: flex;
  gap: ${spacing(4)};
  padding-top: ${spacing(4)};
  background: linear-gradient(
    90deg,
    ${text_colorTextPrimary} 0%,
    ${text_colorTextTertiary} 25%,
    ${text_colorTextPrimary} 50%,
    ${text_colorTextSecondary} 75%,
    ${text_colorTextPrimary} 100%
  );
  background-size: 200% auto;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  animation: gradient 4s linear infinite;
  @keyframes gradient {
    0% {
      background-position: 200% center;
    }
    100% {
      background-position: 0% center;
    }
  }
`
